//
// Single point of contact for Vue
//
// TODO:
//   Conditionally import Vue if no global Vue
//
import Vue from 'vue';
export default Vue;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/utils/vue.js
// module id = 1
// module chunks = 0 1 2 3 4 5 6 7